// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorGst = (client) => ({
    /**
     * `GET /vendor/gst`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGstList
     * @source apps/backend/src/api/vendor/gst/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/gst", { method: "GET", query, headers }),
    /**
     * `PUT /vendor/gst`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGstPut
     * @source apps/backend/src/api/vendor/gst/route.ts
     */
    update: (body, query, headers) => client.fetch("/vendor/gst", { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=gst.js.map